import colton from './Images/image-colton.jpg';
import irene from './Images/image-irene.jpg';
import anne from './Images/image-anne.jpg';

const custTestimonials = [
    {
        image: colton,
        class: 'colton',
        name: 'Colton Smith',
        review: '“ We needed the same printed design as the one we had ordered a week prior. Not only did they find the original order, but we also received it in time. Excellent! ”'
    },
    {
        image: irene,
        class: 'irene',
        name: 'Irene Roberts',
        review: '“ Customer service is always excellent and very quick turn around. Completely delighted with the simplicity of the purchase and the speed of delivery.”'
    },
    {
        image: anne,
        class: 'anne',
        name: 'Anne Wallace',
        review: '“ Put an order with this company and can only praise them for the very high standard. Will definitely use them again and recommend them to everyone! ”'
    },
]

export default custTestimonials;